import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './debtor-finance.component.scss';
import { TooltipsService } from '../../services/tooltips.service';
var DebtorFinance = /** @class */ (function (_super) {
    tslib_1.__extends(DebtorFinance, _super);
    function DebtorFinance(element) {
        return _super.call(this, element) || this;
    }
    DebtorFinance.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.baseUrl = this.baseUrl || window.location.origin;
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector('.form-container__error');
            this.displayDecline = this.form.querySelector('.form-container__declined');
            this.displayMessage = this.form.querySelector(".form-container__message");
        }
        this.buttonSubmit = this.element.querySelector('.js-apply-now__button-debtor-finance');
        this.doneSubmit = this.element.querySelector(".js_done-button");
        this.showMoreBtn = this.element.querySelector('.data-privacy-collapse-show');
        this.showLessBtn = this.element.querySelector('.data-privacy-collapse-hide');
        this.dataPrivacyDetailArea = this.element.querySelector('.data-privacy-detail');
        this.dataSharingGroupHideBtn = this.element.querySelector('.data-sharing-group-hide-btn');
        this.dataSharingGroupShowBtn = this.element.querySelector('.data-sharing-group-show-btn');
        this.dataSharingGroupTextArea = this.element.querySelector('.data-sharing-group');
        this.dataSharing3rdPartyShowBtn = this.element.querySelector('.data-sharing-3rd-party-show-btn');
        this.dataSharing3rdPartyHideBtn = this.element.querySelector('.data-sharing-3rd-party-hide-btn');
        this.dataSharing3rdPartyTextArea = this.element.querySelector('.data-sharing-3rd-party');
        this.dataSharingBoardersHideBtn = this.element.querySelector('.data-sharing-boarders-hide-btn');
        this.dataSharingBoardersShowBtn = this.element.querySelector('.data-sharing-boarders-show-btn');
        this.dataSharingBoardersTextArea = this.element.querySelector('.data-sharing-boarders');
        this.dataSharingTeleSaleHideBtn = this.element.querySelector('.data-sharing-telesale-hide-btn');
        this.dataSharingTeleSaleShowBtn = this.element.querySelector('.data-sharing-telesale-show-btn');
        this.dataSharingTeleSaleTextArea = this.element.querySelector('.data-sharing-telesale');
        this.dataSharingSmsShowBtn = this.element.querySelector('.data-sharing-email-show-btn');
        this.dataSharingSmsHideBtn = this.element.querySelector('.data-sharing-email-hide-btn');
        this.dataSharingSmsTextArea = this.element.querySelector('.data-sharing-email');
        this.dataSharingEmailHideBtn = this.element.querySelector('.data-sharing-sms-hide-btn');
        this.dataSharingEmailShowBtn = this.element.querySelector('.data-sharing-sms-show-btn');
        this.dataSharingEmailTextArea = this.element.querySelector('.data-sharing-sms');
        this.relPartiesHideBtn = this.element.querySelector('.data-rel-parties-hide-btn');
        this.relPartiesShowBtn = this.element.querySelector('.data-rel-parties-show-btn');
        this.relPartiesContent = this.element.querySelector('.data-rel-parties-content');
        this.closeButton = this.element.querySelector('.js-apply-now-modal-close');
        TooltipsService.initTooltips();
    };
    DebtorFinance.prototype.bindEvents = function () {
        var _this = this;
        if (this.buttonSubmit) {
            this.buttonSubmit.addEventListener("click", function (pEvent) {
                var _button = pEvent.target;
                var _form = _button.closest("form");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.submitForm(_form);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }
            });
        }
        if (this.doneSubmit) {
            this.doneSubmit.addEventListener('click', function (event) {
                _this.form.reset();
                window.location.href = '/southafrica/business/products-and-services/borrow-for-your-needs/specialised-financing';
            });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        var ensurerRadios = this.form.querySelectorAll("input[name=\"insurance-book\"]");
        ensurerRadios.forEach(function (radio) {
            radio.addEventListener('change', function () {
                var insurer = _this.dataConsentService.getDataConsentValue(_this.form, 'insurance-book');
                if (insurer === 'YES') {
                    _this.element.querySelector('input[name=insurance-name]').parentElement.parentElement.classList.remove('hidden');
                    _this.element.querySelector('input[name=insurance-name]').classList.add('form__input--required');
                }
                else {
                    _this.element.querySelector('input[name=insurance-name]').parentElement.parentElement.classList.add('hidden');
                    _this.element.querySelector('input[name=insurance-name]').classList.remove('form__input--required');
                }
            });
        });
        this.element.querySelector('input[name=business-reg-number]').addEventListener('input', function (e) {
            var value = e.target.value;
            var _stringLength = parseFloat(value.length);
            var _newLength = (_stringLength - 1);
            var _check = value.substring(_newLength);
            var reg = new RegExp('^[0-9]+$');
            if (reg.test(_check)) {
                if (value.length === 4) {
                    value = value += '/';
                }
                else if (value.length === 11) {
                    value = value += '/';
                }
                else if (value.length > 14) {
                    value = value.substring(0, 14);
                }
            }
            else {
                value = value.substring(0, _newLength);
            }
            e.target.value = value;
        });
        if (this.closeButton) {
            this.closeButton.addEventListener('click', function (event) { return _this.closeForm("close"); });
        }
        this.showLessBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showLessBtn.setAttribute('hidden', 'true');
            _this.showMoreBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.setAttribute('hidden', 'true');
        });
        this.showMoreBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showMoreBtn.setAttribute('hidden', 'true');
            _this.showLessBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.removeAttribute('hidden');
        });
        this.dataSharingGroupHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.setAttribute('hidden', 'true');
            _this.dataSharingGroupHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingGroupShowBtn.removeAttribute('hidden');
        });
        this.dataSharingGroupShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.removeAttribute('hidden');
            _this.dataSharingGroupHideBtn.removeAttribute('hidden');
            _this.dataSharingGroupShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.setAttribute('hidden', 'true');
            _this.dataSharing3rdPartyShowBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharingBoardersShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.removeAttribute('hidden');
            _this.dataSharingBoardersShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.removeAttribute('hidden');
        });
        this.dataSharingBoardersHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersShowBtn.removeAttribute('hidden');
        });
        this.dataSharingTeleSaleShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.removeAttribute('hidden');
            _this.dataSharingTeleSaleShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingTeleSaleHideBtn.removeAttribute('hidden');
        });
        this.dataSharingTeleSaleHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.setAttribute('hidden', 'true');
            _this.dataSharingTeleSaleHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingTeleSaleShowBtn.removeAttribute('hidden');
        });
        this.dataSharingSmsShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.removeAttribute('hidden');
            _this.dataSharingSmsShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingSmsHideBtn.removeAttribute('hidden');
        });
        this.dataSharingSmsHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.setAttribute('hidden', 'true');
            _this.dataSharingSmsHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingSmsShowBtn.removeAttribute('hidden');
        });
        this.dataSharingEmailShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.removeAttribute('hidden');
            _this.dataSharingEmailShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingEmailHideBtn.removeAttribute('hidden');
        });
        this.dataSharingEmailHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.setAttribute('hidden', 'true');
            _this.dataSharingEmailHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingEmailShowBtn.removeAttribute('hidden');
        });
        var exitButton = this.element.querySelector('.exit-button');
        var goBackButton = this.element.querySelector(".go-back-button");
        goBackButton.addEventListener('click', function (event) {
            _this.checkCurrentDebtorToYes();
            _this.displayFields.classList.remove("hidden");
            _this.displayMessage.classList.add("hidden");
        });
        exitButton.addEventListener('click', function (event) {
            _this.form.reset();
            window.location.href = '/southafrica/business/products-and-services/borrow-for-your-needs/specialised-financing';
        });
    };
    DebtorFinance.prototype.dtmVirtualPage = function (pPageNameNew) {
        var taggingValue = pPageNameNew === 'thank you' ?
            "business:products and services:borrow for your needs:specialised financing:debtor-finance-form:"
            : 'confirmational | Callmeback specialised financing debtor finance|';
        dataLayer.pageName =
            taggingValue +
                pPageNameNew;
        if (typeof _satellite == "object") {
            _satellite.track("globalVirtualPageView");
        }
    };
    DebtorFinance.prototype.submitForm = function (form) {
        var _this = this;
        var email = form.querySelector("input[name=email]");
        var recipient = form.querySelector("input[name=recipient]");
        var subject = form.querySelector("input[name=subject]");
        var description = form.querySelector("input[name=product]");
        var firstname = form.querySelector("input[name=first-name]");
        var lastname = form.querySelector("input[name=last-name]");
        var businessName = form.querySelector("input[name=business-name]");
        var businessAddress = form.querySelector("input[name=business-address]");
        var businessRegNumber = form.querySelector("input[name=business-reg-number]");
        var businessEmailAddress = form.querySelector("input[name=business-email-address]");
        var phoneNumber = form.querySelector("input[name=phone-number]");
        var contactPerson = form.querySelector("input[name=contact-person]");
        var businessIndustry = form.querySelector("select[name=business-industry]");
        var natureOfFinance = form.querySelector("select[name=nature-of-finance]");
        var monthlyTurnover = form.querySelector("select[name=monthly-turnover]");
        var amountRequired = form.querySelector("select[name=amount-required]");
        var popiaConsent = form.querySelector("input[name=popia-consent]");
        var insuranceName = form.querySelector("input[name=insurance-name]");
        var clientNameOne = form.querySelector("input[name=client-name-one]");
        var clientNameTwo = form.querySelector("input[name=client-name-two]");
        var clientNameThree = form.querySelector("input[name=client-name-three]");
        var _postData = {
            'email': (email ? email.value : ""),
            'recipient': (recipient ? recipient.value : ""),
            'subject': (subject ? subject.value : ""),
            'product': (description ? description.value : ""),
            'firstName': (firstname ? firstname.value : ""),
            'lastName': (lastname ? lastname.value : ""),
            'businessName': (businessName ? businessName.value : ""),
            'businessAddress': (businessAddress ? businessAddress.value : ""),
            'businessRegNumber': (businessRegNumber ? businessRegNumber.value : ""),
            'businessEmailAddress': (businessEmailAddress ? businessEmailAddress.value : ""),
            'contactPerson': (contactPerson ? contactPerson.value : ""),
            'phoneNumber': (phoneNumber ? phoneNumber.value : ""),
            'businessIndustry': (businessIndustry ? businessIndustry.value : ""),
            'insuranceName': (insuranceName ? insuranceName.value : ""),
            'natureOfFinance': (natureOfFinance ? natureOfFinance.value : ""),
            'monthlyTurnover': (monthlyTurnover ? monthlyTurnover.value : ""),
            'amountRequired': (amountRequired ? amountRequired.value : ""),
            'clientNameOne': (clientNameOne ? clientNameOne.value : ""),
            'clientNameTwo': (clientNameTwo ? clientNameTwo.value : ""),
            'clientNameThree': (clientNameThree ? clientNameThree.value : ""),
            'financialStatement': this.dataConsentService.getDataConsentValue(this.form, 'financial-statement'),
            'managementAccessAccount': this.dataConsentService.getDataConsentValue(this.form, 'management-access-account'),
            'insuranceBook': this.dataConsentService.getDataConsentValue(this.form, 'insurance-book'),
            'currentDebtorBook': this.dataConsentService.getDataConsentValue(this.form, 'current-debtor-book'),
            'tradingYears': this.dataConsentService.getDataConsentValue(this.form, 'trading-years'),
            'dataPrivacyConsent': ((popiaConsent ? (popiaConsent.checked ? "YES" : "NO") : "NO")),
            'dataSharingGroup': this.dataConsentService.getDataConsentValue(form, 'data-sharing-group'),
            'dataSharing3rdParty': this.dataConsentService.getDataConsentValue(form, 'data-sharing-3rd-party'),
            'dataSharingBoarders': this.dataConsentService.getDataConsentValue(form, 'data-sharing-boarders'),
            'dataSharingTelesale': this.dataConsentService.getDataConsentValue(form, 'data-sharing-telesale'),
            'dataSharingEmail': this.dataConsentService.getDataConsentValue(form, 'data-sharing-email'),
            'formLocation': this.formLocationService.getLocation(),
        };
        this.showDisplayView("loader");
        var url = this.baseUrl + "/bcleadUtils/debtor-finance-lead";
        // config
        var _config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, _postData, _config).then(function (pResponse) {
            if (pResponse.data === "invalid") {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.showDisplayView("error");
            }
            else {
                _this.analyticsService.dtmFormComplete("complete", pResponse.code);
                _this.showDisplayView("success");
                _this.dtmVirtualPage('thank you');
            }
        }).catch(function (pError) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    DebtorFinance.prototype.closeForm = function (type) {
        if (type === "close") {
            this.analyticsService.dtmFormAbandon();
        }
        else {
            // this.analyticsService.dtmFormComplete(`complete`, `true`);
            // this.analyticsService.completeDtmApplication();
        }
        this.form.reset();
        window.location.href = '/southafrica/business/products-and-services/borrow-for-your-needs/specialised-financing';
    };
    DebtorFinance.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        this.displayMessage.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            case "message":
                this.displayMessage.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
        }
    };
    DebtorFinance.prototype.checkCurrentDebtorToYes = function () {
        var currentDebtorBookRadios = this.form.querySelectorAll("input[name=\"current-debtor-book\"]");
        currentDebtorBookRadios.forEach(function (radio) {
            radio.checked = false;
        });
    };
    return DebtorFinance;
}(Base));
export { DebtorFinance };



//////////////////
// WEBPACK FOOTER
// ./components/debtor-finance/debtor-finance.component.ts
// module id = 743
// module chunks = 0